module.exports = __webpack_public_path__ + "img/kristina-n-berge.c84331bd.png";